var hidedTeacherSlide = null;

$('.teachers-slider-js').each((key, slider) => {
    let $slider = $(slider);
    $slider.owlCarousel({
        margin: 20,
        responsive: {
            0: {
                items: 1,
                dots: true,
            },
            561: {
                items: 2,
            },
            768: {
                items: 3,
            },
            1200: {
                items: 4,
            },
        },
        dots: false,
        navText: ['&larr;', '&rarr;'],
        nav: true,
        // autoHeight:true,

        onInitialized(){
            setTimeout(() => {
                updateCarousel(slider);
            }, 50);
        },
    });
});

$(document).on('click', '.teacher-slide-js', function () {
    let teacherId = parseInt($(this).data('teacher'));
    let currentTeacherId = parseInt($('.teacher-info.active').data('teacher'));
    if(teacherId === currentTeacherId)
        return;

    let $old = $('.teacher-info.active,.teacher-image.active,.teacher-achievements.active');
    let $new =  $(`.teacher-info[data-teacher=${teacherId}],.teacher-image[data-teacher=${teacherId}],.teacher-achievements[data-teacher=${teacherId}]`);

    $old.animate({opacity: 0}, 300);

    setTimeout(() => {
        $old.removeClass('active');
        $new.addClass('active').css({opacity: 0});
        $new.animate({opacity: 1}, 300);
        updateCarousel(document.querySelector('.teachers-slider-js'));
    }, 300);
});


//убираем из слайдера слайд с выбранным преподом
function updateCarousel(slider) {
    let $slider = $(slider);
    let currentTeacherId = parseInt($('.teacher-info.active').data('teacher'));
    let slide = slider.querySelector(`.teacher-slide-js[data-teacher="${currentTeacherId}"]`);
    let html = slide.outerHTML;

    if(!hidedTeacherSlide){
        let $slides = $(slider).find('.teacher-slide-js');
        let position = $slides.index(slide);
        $slider.trigger('remove.owl.carousel', position);
        $slider.trigger('refresh.owl.carousel');
    }else {
        $(slide).replaceWith(hidedTeacherSlide.html);
    }

    hidedTeacherSlide = {html};
}


$('.load-more-teachers-js').click(function() {
    let page = parseInt(this.getAttribute('data-next-page'));
    showLoadingOverlay();

    $.get('/wp-json/api/v1/teachers/more?page=' + page, data => {
        hideLoadingOverlay();
        let block = this.closest('.teachers-list-cont').querySelector('.teachers-list');
        block.insertAdjacentHTML('beforeend', data.content);
        if(data.hasMore){
            this.setAttribute('data-next-page', page + 1);
        }else{
            $(this.remove());
        }
    }).fail(() => {
        hideLoadingOverlay();
    });
});

$(document).on('click', '.teacher-more-js', function(e) {
    e.preventDefault();

    openModal(this.closest('.teacher-item').outerHTML);
});
